/**
 * Payment Status Badge Component
 *
 * Displays a colored badge for payment status
 */

import {
	getPaymentStatusLabel,
	getPaymentStatusClass,
} from '../utils/paymentHelpers';

/**
 * PaymentStatusBadge Component
 *
 * @param {Object} props           - Component props
 * @param {string} props.status    - Payment status
 * @param {string} props.className - Additional CSS classes
 * @return {JSX.Element} Status badge element
 */
const PaymentStatusBadge = ( { status, className = '' } ) => {
	if ( ! status ) {
		return null;
	}

	const statusClass = getPaymentStatusClass( status );
	const statusLabel = getPaymentStatusLabel( status );

	return (
		<span
			className={ `nb-inline-flex nb-items-center nb-rounded-full nb-px-2.5 nb-py-0.5 nb-text-xs nb-font-medium ${ statusClass } ${ className }` }
		>
			{ statusLabel }
		</span>
	);
};

export default PaymentStatusBadge;
